import { Role, SecondaryRole } from '..';
import {
  compose as lcompose,
  find as lfind,
  getOr as lgetOr,
  defaultTo as ldefaultTo,
} from 'lodash/fp';
import { pathOr } from 'rambda';
import { of, chain, map } from 'fp-ts/Reader';

export const roleKey = ({ deaNo, name }: { deaNo: string; name: string }) =>
  `${deaNo}-${name}`;

export const teamEnableRoles = [
  'REG',
  'POP',
  'APO',
  'APC',
  'AAC',

  'RGP',
  'RGA', // TODO remove
  // 'ALT',
  // 'PRN',
];


export const roles: Role[] = [
  { value: 'REG', label: 'Registrant', level: 0 },
  { value: 'POP', label: 'Principal Coordinator', level: 0 },
  { value: 'APO', label: 'Alternate Coordinator', level: 0 },
  { value: 'POA', label: 'Power of Attorney (POA)', level: 0 },
  {
    value: 'APC',
    label: 'Admin Principal Coordinator',
    level: 0,
  },
  {
    value: 'AAC',
    label: 'Admin Alternate Coordinator',
    level: 0,
  },

  { value: 'RGA', label: 'Registrant-Alternate Coordinator', level: 1 }, // TODO remove
  { value: 'RGP', label: 'Registrant-Principal Coordinator', level: 1 },

  // {
  //   value: 'PRN',
  //   label: 'Principal Coordinator - without Signing Cert',
  //   level: 1,
  // },

  // {
  //   value: 'ALT',
  //   label: 'Alternate Coordinator - without Signing Cert',
  //   level: 1,
  // },
];

export const mapRole = (role: string) => {
  let match = roles.find(r => r.value === role);
  return match ? match.label : role;
}

export const secondaryRoles: SecondaryRole[] = [
  // Registrant
  {
    parent: 'REG',
    value: 'RGA-RGP',
    label: 'Yes',
    level: 1,
    default: false,
  },
  {
    parent: 'REG',
    value: 'REG',
    label: 'No',
    level: 1,
    default: true,
  },

  {
    parent: 'RGA-RGP',
    value: 'RGP',
    label: 'Principal Coordinator',
    level: 2,
    default: true,
  },

  // Principal Coordinator
  {
    parent: 'POP',
    value: 'POP',
    label: 'Yes',
    level: 1,
    default: false,
  },
  // {
  //   parent: 'POP',
  //   value: 'PRN',
  //   label: 'No',
  //   level: 1,
  //   default: true,
  // },

  // Alternate Coordinator
  {
    parent: 'APO',
    value: 'APO',
    label: 'Yes',
    level: 1,
    default: false,
  },
  // {
  //   parent: 'APO',
  //   value: 'ALT',
  //   label: 'No',
  //   level: 1,
  //   default: true,
  // },
];

export const dbRoleToThirdRole = (value: string) =>
  lcompose(
    lgetOr(null, 'value'),
    lfind<SecondaryRole>({ value, level: 2 })
  )(secondaryRoles);

export const dbRoleToSecondaryRole = (value: string) =>
  lcompose(
    ldefaultTo(
      lcompose(
        lgetOr(null, 'value'),
        lfind<SecondaryRole>({ value, level: 1 })
      )(secondaryRoles)
    ),
    lgetOr(null, 'parent'),
    lfind<SecondaryRole>({ value, level: 2 })
  )(secondaryRoles);

const parent: (a: SecondaryRole | undefined) => string = lgetOr('', 'parent');

export const dbRoleToRole = lcompose(
  chain(a => env => a || env),
  map(parent),
  map((second: string | null) =>
    lfind<SecondaryRole>({ value: second || '' })(secondaryRoles)
  ),
  map(dbRoleToSecondaryRole),
  of
);

export const roleLabel = (roles: Role[]) => (value: string) =>
  lcompose(pathOr<string>(value, 'label'), lfind<Role>({ value }))(roles);
